module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-Heavy.7969648.eot";